export const COLUMNS = [
  {
    Header: 'Id',
    Footer: 'Id',
    accessor: 'productId',
    disableFilters: true,
    sticky: 'left'
  },
  {
    Header: 'Title',
    Footer: 'Title',
    accessor: 'productTitle',
    sticky: 'left'
  },
  {
    Header: 'Image',
    Footer: 'Image',
    accessor: 'productImg',
    sticky: 'left'
  }
  // {
  //   Header: 'Action',
  //   Footer: 'Action',
  //   // accessor: 'action'
  // }
]